import React, { useEffect, useRef } from 'react';
import JsBarcode from "jsbarcode"
import '../barcodeStyle.css'
function BarcodeGenerator({ barcode_data }) {
    const barcodeRef = useRef(null);

    useEffect(() => {
        if (barcodeRef.current) {
            JsBarcode(barcodeRef.current, barcode_data.barcode, { width: 2, height: 40 });
        }
    }, [barcode_data]);
    return (
        <>
            <div className='barcodeGeneratorContainer mb-3' style={{ width: "2in", backgroundColor: "white", overflowX: "hidden", display: "inline-block" }}>
                <b style={{ fontSize: "9px" }} className="ms-2">{barcode_data.label.slice(0, 16)}</b>
                <br/>
                <svg className='img-fluid' ref={barcodeRef}></svg>
            </div>
        </>
    );
}

export default BarcodeGenerator;